'use client'

import { useContext, useEffect, useRef } from "react";
import NavHeader from "./nav_header";
import SideHeader from "./side_header";
import { DeviceContext } from "@/context/deviceContext";
import LocaleSelect from "../locale/locale_select";

export default function Header(){
    const headerRef = useRef<HTMLDivElement>(null)
    return (
        <header id="site-header" className="aside-layout" ref={headerRef}>
            <SideHeader />
            <LocaleSelect />
        </header>
    )
}